import Vue from "vue";
import { Notification } from "element-ui";

const chat = {
    state: {
        info: "",
        message: [],
        top: true
    },
    actions: {
        /* ------------------------------ 消息部分 ------------------------------ */
        // 刷新当前消息
        refreshActiveMessage(store) {
            if (store.state.top) {
                Vue.nextTick(() => {
                    var scroll = document.querySelector("#box");
                    if (scroll) {
                        scroll.scrollTop = scroll.scrollHeight;
                    }
                });
            }
        },
        // 用户聊天
        userChat(store, data) {
            store.dispatch("resetInformation");
            store.dispatch("setUserInformation", data);
        },
        // 重置信息
        resetInformation(store) {
            store.state.info = "";
            store.state.top = true;
        },
        // 存储用户信息
        setUserInformation(store, data) {
            if (localStorage.getItem("userInfo")) {
                store.state.info = "";
                var userInfo = JSON.parse(localStorage.getItem("userInfo"));
                var info = {
                    myInfo: {
                        id: userInfo.doctor_id,
                        name: userInfo.doctor_name,
                        image: userInfo.doctor_imgsurl
                    },
                    youInfo: data
                };
                store.state.info = info;
                var none = true;
                store.state.message.map(item => {
                    if (item.id == store.state.info.youInfo.id) {
                        none = false;
                    }
                });
                if (none) {
                    store.dispatch("RCloudGetHistortyMessage", info);
                } else {
                    store.dispatch("refreshActiveMessage");
                }
            } else {
                this.$store.dispatch("logout");
            }
        },
        // 存储新消息
        setMessage(store, message) {
            var none = true;
            store.state.message.map(item => {
                if (item.id == store.state.info.youInfo.id) {
                    none = false;
                    item.message.push(message);
                }
            });
            if (none) {
                var data = {
                    id: store.state.info.youInfo.id,
                    message: [message]
                };
                store.state.message.push(data);
            }
            store.dispatch("refreshActiveMessage");
        },
        // 存储消息记录
        setMessage(store, message) {
            var none = true;
            store.state.message.map(item => {
                if (item.id == store.state.info.youInfo.id) {
                    none = false;
                    item.message.push(message);
                }
            });
            if (none) {
                var data = {
                    id: store.state.info.youInfo.id,
                    message: [message]
                };
                store.state.message.push(data);
            }
            store.dispatch("refreshActiveMessage");
        },
        // 存储消息记录
        setHistoryMessage(store, list) {
            var none = true;
            store.state.message.map(item => {
                if (item.id == store.state.info.youInfo.id) {
                    none = false;
                    for(var i = list.length - 1; i >= 0; i--) {
                        item.message.splice(0, 0, list[i]);
                    }
                }
            });
            if (none) {
                var data = {
                    id: store.state.info.youInfo.id,
                    message: list
                };
                store.state.message.push(data);
            }
            if (store.state.top) {
                store.dispatch("refreshActiveMessage");
            } else {
                store.state.top = true;
            }
        },
        // 没有消息记录
        noHistoryMessage(store, id) {
            store.state.message.map(item => {
                if (item.id == id) {
                    item.noMessage = true;
                }
            });
        },
        // 获取消息
        getMessage(store, message) {
            if (store.state.info.youInfo) {
                if (store.state.info.youInfo.id == message.senderUserId) {
                    var data = {
                        id: store.state.info.youInfo.id,
                        image: store.state.info.youInfo.image,
                        content: message.content.content,
                        status: 2,
                        messageType: message.messageType,
                        time: message.sentTime
                    };
                    store.dispatch("setMessage", data);
                }
            }
        },
        // 发送图片消息
        setImageMessage(store, image) {
            var data = {
                id: store.state.info.myInfo.id,
                image: store.state.info.myInfo.image,
                content: image,
                status: 1,
                messageType: "ImageMessage",
                time: new Date().getTime()
            };
            // 1.添加消息记录
            store.dispatch("setMessage", data);
            // 2.发给融云记录
            var message = {
                targetId: store.state.info.youInfo.id,
                base64Str: image,
                imageUri: image
            };
            store.dispatch("RCloudSendImage", message);
        },
        // 发送文本消息
        setTextMessage(store, text) {
            if (text) {
                var data = {
                    id: store.state.info.myInfo.id,
                    image: store.state.info.myInfo.image,
                    code: 1,
                    content: text,
                    status: 1,
                    messageType: "TextMessage",
                    time: new Date().getTime()
                };
                // 1.添加消息记录
                store.dispatch("setMessage", data);
                // 2.发给融云记录
                var message = {
                    id: store.state.info.youInfo.id,
                    content: text,
                    message: data
                };
                store.dispatch("RCloudSendText", message);
            } else {
                Notification.warning("不能发送空的内容！");
            }
        }
    },
}

export default chat;


// WEBPACK FOOTER //
// ./src/store/modules/talk.js